import { useEffect, useState } from 'react'
import { useGlobalState } from '../../hooks/useGlobalState'
import { ACTIONS } from '../../state'


export const Checkbox = ({ checked, cartItem, addOn }) => {
    const { dispatch } = useGlobalState()
    const [isChecked, setIsChecked] = useState(checked)

    useEffect(() => {
        setIsChecked(checked)
    }, [checked])

    const handleChecked = (e) => {
        setIsChecked(e.target.checked)
        if (e.target.checked) {
            dispatch({ type: ACTIONS.ADD_TICKET_ADDONS, payload: { cartItem, addOn } })
        } else {
            dispatch({ type: ACTIONS.REMOVE_TICKET_ADDONS, payload: { cartItem, addOn } })
        }
    }

    return (
        <div className='checkbox' >
            <input onChange={handleChecked} type="checkbox" name="checkbox" id="checkbox" checked={isChecked} />
        </div>
    )
}
